(function ($) {
    function jsUcfirst(string) {
        return string.charAt(0).toUpperCase() + string.slice(1);
    }

    function jsLcfirst(string) {
        return string.charAt(0).toLowerCase() + string.slice(1);
    }

    function scrollToContactBlock(region) {
        var contactBlock = $('.map-contact-block[data-region-name="' + jsLcfirst(region) + '"]');
        var scrollAmount = contactBlock[0].offsetTop;
        $('.map-contact-block').removeClass('active');
        contactBlock.addClass('active');

        if (window.matchMedia("(max-width: 1230px)").matches) {
            $('html, body').animate({
                scrollTop: $('.map-contacts')[0].offsetTop
            }, 500);
        }

        $('.map-contacts .simplebar-content-wrapper').animate({
            scrollTop: scrollAmount
        }, 500);
    }

    if ($('.page-template-template-regions').length) {
        new autoComplete({
            selector: '.map-filters .region-search',
            delay: 0,
            minChars: 1,
            source: function (term, suggest) {
                term = term.toLowerCase();

                var matches = [];

                for (i = 0; i < regionNames.length; i++) {
                    if (~regionNames[i].toLowerCase().indexOf(term)) {
                        matches.push(jsUcfirst(regionNames[i]));
                    }
                }
                suggest(matches);
            },
            onSelect: function (e, term, item) {
                scrollToContactBlock($(item).data('val'));
                $('.map-filters .region-select').val('').trigger('change');
                $('.region-map .region-block').removeClass('active');
            }
        });

        $('.map-filters .region-select').each(function (index, el) {
            $(this).select2({
                closeOnSelect: true,
                minimumResultsForSearch: $(this).data('search-results'),
                placeholder: $(this).data('input-placeholder')
            })

            $(this).on('select2:select', function () {
                scrollToContactBlock($(this)[0].value);
                $('.map-filters .region-search').val('');
                $('.region-map .region-block').removeClass('active');
            });
        });

        $('.region-map .region-block:not(.no-contacts)').on('click', function () {
            var id = $(this).attr('id');
            id = id.replace("-", " ");
            scrollToContactBlock(id);
            $('.map-filters .region-select').val('').trigger('change');
            $('.map-filters .region-search').val('');
            $('.region-map .region-block').removeClass('active');
        });

        $('.map-contacts .map-contact-block').on('click', function() {
            var name = $(this).data('region-name');
            name = name.replace("-", " ");
            $('.region-map .region-block').removeClass('active');
            $('.region-map .region-block[id="'+name+'"]').click().addClass('active');
        });

    }

})(jQuery);